import { parseResponse } from '$lib/client/responseHelpers';

import { getStreamConfig } from '@api/streaming/streaming';

export async function getStripchatBroadcastConfig() {
    const configResp = await getStreamConfig(true);
    const data = parseResponse(configResp);

    if (!data) {
        console.error('No config');
        return null;
    }
    if (!data?.stripChat) {
        console.error('No stripchat stream config');
        return null;
    }
    return data.stripChat;
}
